import { useEffect } from 'react';
import { SerializedError } from '@reduxjs/toolkit';

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { UserRoleBindingTable } from '../role-binding/UserRoleBindingTable';
import { TenantRoleBindingTable } from '../role-binding/TenantRoleBindingTable';
import {
  getRoleAction,
  selectRoleDetail,
} from './roleSlice';

type Props = {
  tenant_id: string;
  role_id: string;
  closeCallback: (error?: SerializedError) => void;
};

export function RoleView({ tenant_id, role_id, closeCallback }: Props) {
  const dispatch = useAppDispatch();
  const role = useAppSelector(selectRoleDetail);

  useEffect(() => {
    dispatch(getRoleAction({ tenant_id, role_id }));
  }, [tenant_id, role_id, dispatch]);

  if (!role) {
    return null;
  }
  return (
    <>
      <div className="mb-3 row">
        <label htmlFor="role_id" className="col-sm-3 col-form-label">ID</label>
        <div className="col-sm-6">
          <span id="role_id" className="form-control-plaintext">{role.role_id}</span>
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="role_name" className="col-sm-3 col-form-label">Name</label>
        <div className="col-sm-6">
          <span id="role_name" className="form-control-plaintext">{role.name}</span>
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="role_type" className="col-sm-3 col-form-label">Type</label>
        <div className="col-sm-6">
          <span id="role_type" className="form-control-plaintext">{role.type}</span>
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="role_title" className="col-sm-3 col-form-label">Title</label>
        <div className="col-sm-6">
          <span id="role_title" className="form-control-plaintext">{role.title}</span>
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="role_description" className="col-sm-3 col-form-label">Description</label>
        <div className="col-sm-6">
          <span id="role_description" className="form-control-plaintext">{role.description}</span>
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="role_state" className="col-sm-3 col-form-label">State</label>
        <div className="col-sm-6">
          <span id="role_state" className="form-control-plaintext">{role.state}</span>
        </div>
      </div>
      <div className="scope-list mt-3">
        <div className="d-flex justify-content-between py-4">
          <h3>{role.scopes.length || 'No'} assigned scopes</h3>
        </div>
        <div className="d-flex flex-column w-50">
          {role.scopes.map((scope_id) => 
            <div className="border px-1 mx-1 my-1 border-info rounded-3 d-flex justify-content-between"
              key={scope_id}>
              {scope_id}
            </div>
          )}
        </div>
      </div>
      {role.type !== 'shared' &&
      <UserRoleBindingTable role_id={role.role_id} />
      }
      {role.type === 'shared' &&
      <TenantRoleBindingTable role_id={role.role_id} />
      }
    </>
  );
}
